import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { MaterialModule } from 'src/app/material-module';
import { InlineSVGModule } from 'ng-inline-svg';

import { SafeHtmlPipe } from 'src/app/pipes/safehtml';
import { LineChartComponent } from './charts/linechart/linechart.component';
import { NgApexchartsModule } from "ng-apexcharts";
import { BarChartComponent } from './charts/barchart/barchart.component';
import { FusionChartsModule } from 'angular-fusioncharts';
import { ChartsModule } from 'ng2-charts';
import { WhatsappSupportComponent } from './components/whatsapp-support/whatsapp-support.component';
import { UpdateNotificationComponent } from './components/update-notification/update-notification.component';
import { UpgradeDialogComponent } from './components/upgrade-dialog/upgrade-dialog.component';

// Load FusionCharts
import * as FusionCharts from 'fusioncharts';
// Load Charts module
import * as Charts from 'fusioncharts/fusioncharts.charts';
// Load fusion theme
import * as Fusion from 'fusioncharts/themes/fusioncharts.theme.fusion'
import * as charts from "fusioncharts/fusioncharts.powercharts";
import * as Widgets from "fusioncharts/fusioncharts.widgets";
import * as ExcelExport from "fusioncharts/fusioncharts.excelexport";
import * as timeseries from "fusioncharts/fusioncharts.timeseries";
import { MovilvelocidadComponent } from '../modules/flota/control-velocidad/movilvelocidad.component';
import { MovilParadasComponent } from '../modules/flota/control-paradas/movilparadas.component';
import { ConfirmDialog } from './confirmdialog/confirmdialog.component';


// Add dependencies to FusionChartsModule
FusionChartsModule.fcRoot(
    FusionCharts,
    charts,
    Charts,
    Fusion,
    Widgets,
    ExcelExport,
    timeseries
);

@NgModule({
    imports: [
        CalendarModule,
        CommonModule,
        FormsModule,
        MaterialModule,
        InlineSVGModule.forRoot(),
        NgApexchartsModule,
        FusionChartsModule,
        ChartsModule,
    ],
    declarations: [
        SafeHtmlPipe,
        LineChartComponent,
        BarChartComponent,
        MovilvelocidadComponent,
        MovilParadasComponent,
        ConfirmDialog,
        WhatsappSupportComponent,
        UpdateNotificationComponent,
        UpgradeDialogComponent,
    ],
    exports: [
        CalendarModule,
        CommonModule,
        FormsModule,
        MaterialModule,
        SafeHtmlPipe,
        NgApexchartsModule,
        LineChartComponent,
        BarChartComponent,
        FusionChartsModule,
        ChartsModule,
        MovilvelocidadComponent,
        MovilParadasComponent,
        ConfirmDialog,
        WhatsappSupportComponent,
        UpdateNotificationComponent,
        UpgradeDialogComponent
    ],
    providers: [
        FusionChartsModule
    ]
})

export class SharedModule { }
